/// <reference path="callCenter.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CallCenter {
  
  class ServiceAddressModalController {
    
    private scope: any;
    private modal: angular.material.IDialogService;
    private modalClass: string;
    private okButtonContentKey: string;
    private cancelButtonContentKey: string;
    private headerContentKey: string;
    private message: string;
    private isAddressComplete: boolean;
    public addressData: Model.Address = {};

    static $inject = ["$scope", "$mdDialog", "$translate", "$mdToast", "meevo.components.common.DataService", "service", "clientInfo"];

    constructor($scope: angular.IScope,
      $mdDialog: angular.material.IDialogService,
      private $translate: angular.translate.ITranslateService,
      private $mdToast: angular.material.IToastService,
      private dataService: Meevo.Components.BaseClasses.IDataService,
      private service: any,
      private clientInfo: any) {

      let vm = this;
      vm.scope = $scope;
      vm.modal = $mdDialog;
      vm.dataService = dataService;

      this.configureModal();
    }

    ok = () => {
      if (_.isEmpty(this.addressData.address1) ||
        _.isEmpty(this.addressData.city) ||
        _.isEmpty(this.addressData.state) ||
        _.isEmpty(this.addressData.zipCode)) {

        var toast = this.$mdToast.simple();
        toast.theme("error-toast");
        toast.textContent(this.$translate.instant("ERROR_SERVICE_ADDRESS_REQUIRED"));
        toast.position("top right");
        toast.parent(angular.element("form#serviceAddressForm"));
        toast.hideDelay(5000);
        toast.action("X"); // Will close the toast when clicked.
        this.$mdToast.show(toast);

      } else {
        this.modal.hide({
          isAddressComplete: true,
          address1: this.addressData.address1,
          address2: this.addressData.address2,
          city: this.addressData.city,
          state: this.addressData.state,
          zipCode: this.addressData.zipCode,
          country: this.addressData.country
        });
      }
    }

    cancel = () => {
      this.modal.cancel({
        isAddressComplete: false
      });
    }

    configureModal = () => {
      this.modalClass = "modal-confirm";
      this.headerContentKey = this.$translate.instant("HEADER_SERVICE_ADDRESS") + this.service.shortcut + ": " + this.service.displayName;
      this.okButtonContentKey = "LABEL_OK";
      this.cancelButtonContentKey = "LABEL_CANCEL";

      this.addressData.address1 = this.clientInfo.address.address1;
      this.addressData.address2 = this.clientInfo.address.address2;
      this.addressData.city = this.clientInfo.address.city;
      this.addressData.state = this.clientInfo.address.state;
      this.addressData.zipCode = this.clientInfo.address.zipCode;
      
      if (this.clientInfo.country) {
        this.addressData.country = this.clientInfo.address.country;
      } else {
        this.addressData.country = "USA";
      }
    }
  }

  angular.module("meevo.plugins.callCenter")
    .controller("meevo.plugins.callCenter.serviceAddressModalController", ServiceAddressModalController);
}